import QTable from 'quasar/src/components/table/QTable.js';

export const adminUserTableColumn = (): QTable['columns'] => [
  {
    name: 'info',
    field: row => ({
      id: row.id,
      displayname: row.displayname,
      username: row.username,
      avatar: row.avatar
    }),
    label: 'نام و نام خانوادگی',
    align: 'left',
    style: 'max-width:120px'
  },
  {
    name: 'roles',
    field: 'roles',
    label: 'نقش کاربری',
    align: 'center',
    style: 'max-width:120px',
    format: value => value.join('، ')
  },
  {
    name: 'phone',
    field: 'phone',
    label: 'تلفن',
    align: 'center'
  },
  {
    name: 'wallet',
    field: 'wallet',
    label: 'م.کاربر',
    align: 'center',
    format: value => `${(value)?value.toLocaleString():'عدم موجودی'} ${(value)?'تومان':''}`
  },
  {
    name: 'writer_wallet_amount',
    field: 'writer_wallet_amount',
    label: 'م.نویسنده',
    align: 'center',
    format: value => `${(value)?value.toLocaleString():'عدم موجودی'} ${(value)?'تومان':''}`
  },
  {
    name: 'created_at',
    field: 'created_at',
    label: 'تاریخ عضویت',
    align: 'center'
  },
  {
    name: 'last_login_at',
    field: 'last_login_at',
    label: 'آخرین فعالیت',
    align: 'center'
  },
  {
    name: 'actions',
    field: '',
    label: '',
    align: 'center'
  }
]
